import * as Hooks from 'preact/hooks';

export function useLatest<T>(
    value: T,
    isValid: (value: T) => boolean = v => v !== undefined,
): T | undefined {
    const latest = Hooks.useRef<T | undefined>(undefined);

    const valid = Hooks.useMemo(() => isValid(value), [value]);

    if (valid) {
        latest.current = value;
    }

    return latest.current;
}
